import { Dialog, Kbd } from '@patchbay/ui'
import { KEY_LIST } from '../lib/keys'
import { useWorkspace } from '../lib/workspace'

const SCOPES = [
  ['global', 'Everywhere'],
  ['queue', 'Queue'],
  ['case', 'Case'],
  ['card', 'Focused card'],
  ['board', 'Schedule pipeline'],
] as const

export function KeySheet() {
  const ws = useWorkspace()
  return (
    <Dialog
      open={ws.keySheetOpen}
      onOpenChange={ws.setKeySheetOpen}
      title="Keyboard shortcuts"
      description="Keys never fire while you type in a field or the editor. Every key also has a button; hover a button to see its key."
    >
      <div className="grid gap-5 sm:grid-cols-2">
        {SCOPES.map(([scope, label]) => (
          <section key={scope}>
            <h3 className="mb-1.5 text-xs font-semibold text-subtle">{label}</h3>
            <ul className="space-y-1">
              {KEY_LIST.filter((k) => k.scope === scope).map((k) => (
                <li key={k.id} data-key={k.id} className="flex items-center justify-between gap-3 text-sm">
                  <span>{k.label}</span>
                  <Kbd keys={k.keys} />
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </Dialog>
  )
}
